// GENERATED FILE — DO NOT EDIT.
//
// Source: packages/hpn-chrome/chrome.json in the happypetnet superproject.
// Regenerate with `node scripts/sync-chrome.mjs` from the superproject root.
// Edits here are overwritten and fail `node scripts/check-chrome.mjs`.
//
// chrome-source-sha256: 483b46c736d7

export const HOSTS = {
  "app": "https://app.happypetnet.com",
  "site": "https://happypetnet.com",
  "api": "https://api.happypetnet.com"
};

export const STAGING_HOSTS = {
  "app": "https://dev.happypetnet.com",
  "site": "https://dev-landing.happypetnet.com",
  "api": "https://apidev.happypetnet.com"
};
